import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { computeReviewSummary } from '../../util/reviewSummary';

import { IconReviewStar } from '../../components';

import css from './ProfileReviewSummary.module.css';

/**
 * Overall review summary (average + star bars) for a reviews tab.
 *
 * @component
 */
const ProfileReviewSummary = props => {
  const { reviews = [], reviewType, className } = props;
  const summary = computeReviewSummary(reviews);

  if (summary.count === 0) {
    return null;
  }

  const filledStars = Math.round(summary.average);

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.averageBlock}>
        <div className={css.average}>{summary.average}</div>
        <div className={css.stars} aria-hidden>
          {[1, 2, 3, 4, 5].map(n => (
            <IconReviewStar key={n} className={css.star} isFilled={n <= filledStars} isAriaHidden />
          ))}
        </div>
        <div className={css.countLabel}>
          {reviewType === 'ofProvider' ? (
            <FormattedMessage
              id="ProfilePage.reviewSummaryCustomerCount"
              values={{ count: summary.count }}
            />
          ) : (
            <FormattedMessage
              id="ProfilePage.reviewSummaryBuyerCount"
              values={{ count: summary.count }}
            />
          )}
        </div>
      </div>

      <div className={css.bars}>
        {summary.distribution.map((barCount, index) => {
          const star = 5 - index;
          const pct = summary.count > 0 ? Math.round((barCount / summary.count) * 100) : 0;
          return (
            <div key={star} className={css.barRow}>
              <span className={css.barStar}>{star}</span>
              <IconReviewStar className={css.barStarIcon} isFilled isAriaHidden />
              <div className={css.barTrack}>
                <div className={css.barFill} style={{ width: `${pct}%` }} />
              </div>
              <span className={css.barCount}>{barCount}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileReviewSummary;
